import { Box, Button, FormControl, Input, Stack } from "@chakra-ui/react"
import { ErrorMessage, Formik } from "formik"
import { ComponentProps, FC } from "react"
import { ErrorMessageField } from "src/components/ui"
import { DrawerForm } from "src/components/ui/DrawerForm"
import { InputLabel } from "src/components/ui/InputLabel"
import { FormikOnSubmit } from "src/utils/types"
import { IUserTempPasswordDrawerFormFields } from "."

interface Props extends Omit<ComponentProps<typeof DrawerForm>, "children"> {
	handleSubmit: FormikOnSubmit<IUserTempPasswordDrawerFormFields>
	tempPassword?: string
	tempPasswordExpiresAt?: number
	onCopyPassword?: () => void
	isCopyDisabled?: boolean
	isCopied?: boolean
}

export const UserTempPasswordDrawerFormView: FC<Props> = ({
	handleSubmit,
	tempPassword,
	tempPasswordExpiresAt,
	onCopyPassword,
	isCopyDisabled,
	isCopied,
	...rest
}) => (
	<Formik<IUserTempPasswordDrawerFormFields>
		initialValues={{ action: "" }}
		onSubmit={handleSubmit}
		enableReinitialize={true}
	>
		{({ isSubmitting }) => (
			<DrawerForm
				size="sm"
				headerLabel="Temporary Password"
				submitLabel={tempPassword ? "Rotate Password" : "Generate Password"}
				isSubmitting={isSubmitting}
				{...rest}
			>
				<Stack maxWidth={"sm"} marginX={"auto"} spacing={3}>
					<Box fontSize="sm" color="gray.600">
						Generate a temporary password for login. Permanent password will
						continue to work in parallel.
					</Box>
					<Box fontSize="sm" color="orange.600">
						This password is shown once after generation. Save it securely.
					</Box>

					{tempPassword && (
						<>
							<FormControl>
								<InputLabel label="Temporary Password" />
								<Input value={tempPassword} isReadOnly type="text" />
							</FormControl>
							<Button
								variant="outline"
								colorScheme="blue"
								onClick={onCopyPassword}
								isDisabled={isCopyDisabled}
							>
								{isCopied ? "Copied" : "Copy Password"}
							</Button>
							{typeof tempPasswordExpiresAt === "number" && (
								<Box fontSize="sm" color="gray.600">
									Expires at: {new Date(tempPasswordExpiresAt).toLocaleString()}
								</Box>
							)}
						</>
					)}

					<ErrorMessage component={ErrorMessageField} name="action" />
				</Stack>
			</DrawerForm>
		)}
	</Formik>
)
